<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<h2 class="half">The First Enigma Code-Breaker</h2>
<h2 class="half1">The untold story of Marian Rejewski, who passed the baton to Alan Turing</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half.vue?76b46f99